import { type PlacementCandidate } from "@src/appV2/redesign/PlacementCandidate/types";

interface UseBookingCohortEligibilityParams {
  placementCandidate: Pick<PlacementCandidate, "screeningStatus">;
  isRecruiterScreeningEnabled: boolean;
  /** Whether job interviews feature is enabled */
  isJobInterviewsEnabled?: boolean;
  /** Whether the placement requires an interview */
  requiredInterview?: boolean;
  /** Whether there are missing documents other than the screening document */
  hasNonScreeningDocumentsMissing?: boolean;
  /** Whether the worker is in the interviewsOnJobCards cohort */
  isInterviewsOnJobCardsCohort?: boolean;
}

/**
 * Determines eligibility for document bypass conditions.
 * With the booking flow experiment concluded (screen_first won),
 * screen_last and book_first cohort paths are removed.
 */
export function useBookingCohortEligibility(params: UseBookingCohortEligibilityParams) {
  const {
    isJobInterviewsEnabled = false,
    requiredInterview = false,
    hasNonScreeningDocumentsMissing = false,
    isInterviewsOnJobCardsCohort = false,
  } = params;

  const hasInterviewBookingFlow = isJobInterviewsEnabled && requiredInterview;

  // Allow interviewsOnJobCards cohort to bypass the screening document
  // since screening is disabled for this cohort.
  const canBypassDocumentsForInterviewsCohort =
    isInterviewsOnJobCardsCohort && hasInterviewBookingFlow && !hasNonScreeningDocumentsMissing;

  return {
    canBypassDocumentsForInterviewsCohort,
  };
}

export type BookingCohortEligibilityReturn = ReturnType<typeof useBookingCohortEligibility>;
